import { Form } from "./Form";
export class Order extends Form {
    constructor(container, events) {
        super(container, events);
        this.events = events;
        this._card = container.elements.namedItem('card');
        this._cash = container.elements.namedItem('cash');
        //Используется для переключения кнопок выбора типа оплаты
        if (this._cash) {
            this._cash.addEventListener('click', () => {
                this._cash.classList.add('button_alt-active');
                this._card.classList.remove('button_alt-active');
                this.onInputChange('paymenttype', 'cash');
            });
        }
        if (this._card) {
            this._card.addEventListener('click', () => {
                this._card.classList.add('button_alt-active');
                this._cash.classList.remove('button_alt-active');
                this.onInputChange('paymenttype', 'card');
            });
        }
    }
}
